import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import Slide from 'react-reveal/Slide';




class Products extends Component {
  render() {
    return (
    <div>   
    <section id="work" className="wow fadeIn pt pt-sm-80 text-center">
    <h3>Nos produits</h3>
            <div className="container">
                

          
           
              
                <div className="row">
                <Slide right cascade>
                    <div className="col-md-6">
                    
                         <div className="Teranga_lay">
                           <h3><img src="/assets/img/logos/teranga.png" className="teranga_img teranga_box_title"/></h3>
                        <div className="Teranga_serv">
                            <div className="leave"/>
                            <p className="text_teranga"><b className="bold_word"><img src="/assets/img/logos/teranga.png" className="teranga_img teranga_box"/></b> est un amendement organique structurant du sol. Il est issu de la valorisation des matières d’origine végétales, animales et agro-industrielles. </p>
                            <p className="text_teranga"><b className="bold_word"><img src="/assets/img/logos/teranga.png" className="teranga_img teranga_box"/></b>  bénéficie d’un contrôle strict des matières premières servant à sa fabrication et en particulier des métaux lourds.Le mode d’action des éléments contenus dans le <img src="/assets/img/logos/teranga.png" className="teranga_img teranga_box"/> permet de réduire les pertes par lessivage et les pertes par volatilisation dans l’air. Il augmente la capacité des plantes à capter le CO2 présent dans...</p>
                        </div>
                      <div className="teranga_btn"><a href="/produits/teranga"><button  className="btn btn-md btn-black-line terangabouton">Lire la suite</button></a></div>

                    </div>
                    
                   
                    </div>
                    </Slide>

                    <Slide left cascade>
                    <div className="col-md-6">
                    
                            <div className="Teranga_plus_serv">
                                <h3><img src="/assets/img/logos/terangaplus.png" className="terangaplus_img"/></h3>
                            <div className="plus_serv">
                            <div className="leave_two"/>
                            <p className="text_teranga"><img src="/assets/img/logos/terangaplus.png" className="terangaplus_img terangaplus_box"/>  est un engrais organique riche en éléments nutritifs Majeurs (N-P-K),  en éléments secondaires (Ca - Mg- Na) et en Oligo-éléments d’origine organique. <img src="/assets/img/logos/terangaplus.png" className="terangaplus_img terangaplus_box"/> constitue un engrais organique de croissance par excellence. </p>
                            <p className="text_teranga">Effet du <img src="/assets/img/logos/terangaplus.png" className="terangaplus_img terangaplus_box"/> sur la plante :</p>
                            <p className="text_teranga">Le <img src="/assets/img/logos/terangaplus.png" className="terangaplus_img terangaplus_box"/> a une action indirecte sur le développement des plantes en créant toutes les conditions propices à leur plein épanouissement en :</p>
                        </div>
                     <div className="teranga_btn"><a href="/produits/teranga-plus"><button  className="btn btn-md btn-black-line terangabouton">Lire la suite</button></a></div>

                    </div>


               
                    </div>
                     </Slide>
         
                    </div>
                      </div>
                    <h3 className="nos_serv">Nos Services</h3>
             
           
            
          </section>


    </div>
  
       
        

    )
  }
}
export default Products;


// WEBPACK FOOTER //
// ./src/components/produits.jsx